/**
 * Environment Service Module.
 *
 * @version
 * 2.0.0 LIBENV-99 Implement bcxOauth2HttpService for native HTTP requests
 * 1.31.0 LIBENV-97 Revert breaking changes in wdEnvironmentService
 * 1.30.0 LIBENV-95 Create new Oauth2HttpService to handle native http responses
 * 1.15.0 LIBENV-53 Export wdEnvironmentService as a node module.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2020-2021 Build Centrix
 *
 */

if (typeof angular === 'undefined') {
    angular = require('angular');
}

var Cookies = require('cookies-js');
globalThis.Cookies = Cookies;

var WebductConfiguration = require('./src/es5/helpers/configuration/WebductConfiguration');

var WebductCookieAdapter = require('./src/es5/adapters/cookies/WebductCookieAdapter');
var WebductApiResponseHandler = require('./src/es5/handlers/response/api/WebductApiResponseHandler');
var WebductConstants = require('./src/es5/helpers/constants/WebductConstants');
var WebductOauth2Http = require('./src/es5/helpers/oauth2http/WebductOauth2Http');
var WebductPermissions = require('./src/es5/helpers/permissions/WebductPermissions');
var WebductResources = require('./src/es5/helpers/resources/WebductResources');
var WebductUsers = require('./src/es5/helpers/user/WebductUsers');

var wdApiResponseHandler = require('./src/angularjs/handlers/response/api/wdApiResponseHandler');

var wdConstantService = require('./src/angularjs/services/constants/wdConstantService');
var bcxHttpService = require('./src/angularjs/services/oauth2http/bcxHttpService');
var wdHttpService = require('./src/angularjs/services/oauth2http/wdHttpService');
var bcxOauth2HttpService = require('./src/angularjs/services/oauth2http/bcxOauth2HttpService');
var wdOauth2HttpService = require('./src/angularjs/services/oauth2http/wdOauth2HttpService');
var wdPermissionService = require('./src/angularjs/services/permissions/wdPermissionService');
var wdResourceService = require('./src/angularjs/services/resources/wdResourceService');
var wdConfigurationService = require('./src/angularjs/services/configuration/wdConfigurationService');

var wdConfigurationHelper = require('./src/angularjs/helpers/configuration/wdConfigurationHelper');
var wdOauth2HttpHelper = require('./src/angularjs/helpers/oauth2http/wdOauth2HttpHelper');
var wdConstantHelper = require('./src/angularjs/helpers/constants/wdConstantHelper');
var wdPermissionHelper = require('./src/angularjs/helpers/permissions/wdPermissionHelper');
var wdResourceHelper = require('./src/angularjs/helpers/resources/wdResourceHelper');
var wdUserHelper = require('./src/angularjs/helpers/user/wdUserHelper');

var wdEnvironmentService = require('./src/angularjs/services/environment/wdEnvironmentService');

module.exports = wdEnvironmentService;

// EOF